import React, { useState } from "react"
import Login from "./loginLogs"
import FormsLogo from "../images/ccs-black.svg"

function Logs() {
  const [logs, setLogs] = useState([])
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchText, setSearchText] = useState("")
  const logsPerPage = 10

  // Pagination Logic
  const indexOfLastLog = currentPage * logsPerPage
  const indexOfFirstLog = indexOfLastLog - logsPerPage

  // Search Filter
  const filteredLogs = logs.filter((log) =>
    Object.values(log).some((value) =>
      value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  )

  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog)
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage)

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1)
  }

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1)
  }

  const loadLogs = (logs) => {
    setLogs(logs)
    setIsLoggedIn(true)
  }

  return (
    <div className="logs-container">
      {!isLoggedIn ? (
        <Login onLogin={(data) => loadLogs(data)} />
      ) : (
        <>
          {/* Logo Section */}
          <div className="logs-header">
            <img src={FormsLogo} height={36} width={220} alt="Consensus Logo" />
            {/* <button className="logout-button" onClick={handleLogout}>
              Logout
            </button> */}
          </div>

          {/* Search Input */}
          <div className="logs-search">
            <input
              type="text"
              placeholder="Search logs..."
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value)
                setCurrentPage(1) // Reset to the first page on search
              }}
            />
          </div>

          {/* Logs List */}
          <div className="logs-content">
            <table className="logs-table">
              <thead>
                <tr>
                  <th className="logs-th" style={{ width: "20%" }}>
                    Audit Id
                  </th>
                  <th className="logs-th" style={{ width: "10%" }}>
                    Date
                  </th>
                  <th className="logs-th" style={{ width: "10%" }}>
                    Event Type
                  </th>
                  <th className="logs-th" style={{ width: "20%" }}>
                    File Name
                  </th>
                  <th className="logs-th" style={{ width: "20%" }}>
                    Group Name
                  </th>
                  <th className="logs-th" style={{ width: "20%" }}>
                    User
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentLogs.map((log, index) => (
                  <tr key={index}>
                    <td className="logs-td" style={{ width: "20%" }}>
                      {log.auditId}
                    </td>
                    <td className="logs-td" style={{ width: "10%" }}>
                      {log.createdDatetime}
                    </td>
                    <td className="logs-td" style={{ width: "10%" }}>
                      {log.eventType}
                    </td>
                    <td className="logs-td" style={{ width: "20%" }}>
                      {log.fileName}
                    </td>
                    <td className="logs-td" style={{ width: "20%" }}>
                      {log.groupName}
                    </td>
                    <td className="logs-td" style={{ width: "20%" }}>
                      {log.userId}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="logs-pagination">
            <button
              className="logs-button"
              onClick={handlePrev}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="logs-page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="logs-button"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default Logs
